import { DomainMessagesTypes } from 'shared/domain/messages/message';
import { siteEntityToModel } from 'shared/domain/site/mapping/toModel';
import { SiteModel } from 'shared/domain/site/types/model';
import { getUsersSynchronized } from 'serviceWorker/services/users/getUsers';
import { debugLog } from 'shared/logger/debugLog';
import * as dbSites from '../db/sites/sites';
import * as dbSitesService from '../db/sites/sitesService';
import { siteContract } from 'shared/domain/site/siteContract';
import { makeErrorPublisher, makeEventPublisher, makeLoadedEventPublisher, readCollectionPayload } from 'serviceWorker/broadcasts/publishers';

const broadcastSiteError = makeErrorPublisher(
  siteContract
);

export const broadcastAllSites = makeLoadedEventPublisher(
  siteContract,
  DomainMessagesTypes.allSites,
  () => readCollectionPayload(dbSitesService, async () => {
    const [sites, users] = await Promise.all([
      dbSites.get(),
      getUsersSynchronized(),
    ]);
    return sites.map((site) => siteEntityToModel(site, users));
  })
);

export const broadcastUploadedSite = makeEventPublisher(siteContract, DomainMessagesTypes.uploadedEntity);

export const broadcastUpdatedSite = makeEventPublisher(siteContract, DomainMessagesTypes.updatedEntity);

export const broadcastDeletedSite = makeEventPublisher(siteContract, DomainMessagesTypes.deletedEntity);

/** `uniqueId` of the failed change lets its command reject with this error. */
export const broadcastUploadedSiteError = (
  error: unknown,
  messageId?: string | null,
  uniqueId?: string
): void => {
  debugLog('broadcastUploadedSiteError', error, messageId, uniqueId);
  broadcastSiteError(DomainMessagesTypes.failUploadedEntity, error, {
    messageId: messageId || undefined,
    uniqueId,
  });
};
